import styled from 'styled-components'

import STYLE_GUIDE from '@/shared/constants/styleGuide'

export const OtpCertFormContainer = styled.div`
   {
    @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
      width: 800px;
      margin: 109px -150px 150px auto;
      > h1 {
        margin-bottom: 61px;
        font-weight: 800;
        font-size: 30px;
        line-height: 42px;
      }

      > section {
        width: 400px;
        margin-bottom: 30px;
      }

      .cancel_submit {
        cursor: pointer;
        background-color: ${STYLE_GUIDE.COLOR.main01};
        border: none;
        border-radius: 8px;
        color: white;
        width: 50%;
        height: 50px;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        font-family: GmarketSansBold, serif;
      }

      .cancel_notice-text {
        margin: 30px 0 0 -10px;
        width: 54%;
        color: ${STYLE_GUIDE.COLOR.warning};
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
      }

      .mypage_guide {
        width: 50%;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: ${STYLE_GUIDE.COLOR.grey02};
        margin: 30px 0;

        > span {
          cursor: pointer;
          padding-left: 7px;
          text-align: center;
          text-decoration-line: underline;
          font-weight: 500;
          line-height: 20px;
          font-family: GmarketSansMedium, serif;
          color: ${STYLE_GUIDE.COLOR.main01};
        }
      }
    }
    @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
      margin-top: -75px;
      width: 320px;
      display: inline-block;
      > h1 {
        font-weight: 800;
        font-size: 29px;
        line-height: 42px;
        color: ${STYLE_GUIDE.COLOR.grey01};
        margin-bottom: 40px;
        width: 100%;
        display: inline-block;
      }

      > section {
        margin-bottom: 18px;
      }

      .cancel_submit {
        cursor: pointer;
        background-color: ${STYLE_GUIDE.COLOR.main01};
        color: #fff;
        border-radius: 8px;
        width: 100%;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        text-align: center;
        border: none;
        height: 50px;
        font-family: GmarketSansBold, serif;
      }

      .cancel_notice-text {
        font-weight: 700;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        color: #ff3f33;
      }

      .mypage_guide {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: ${STYLE_GUIDE.COLOR.grey02};

        > span {
          cursor: pointer;
          padding-left: 10px;
          color: ${STYLE_GUIDE.COLOR.main01};
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          font-family: GmarketSansBold, serif;
          text-decoration: underline;
        }
      }
    }
  }
`
